import store from '@/state/store';

export default [
  {
    path: '/portal',
    name: 'portal',
    component: () => import('../views/account/portal.vue'),
    meta: {
      title: 'AAI Systems Portal',
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login.vue'),
    meta: {
      title: 'Login',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/account/register.vue'),
    meta: {
      title: 'Register',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        // if (store.getters["auth/loggedIn"]) {
        //   // Redirect to the home page instead
        //   next({ name: "default" });
        // } else {
        //   // Continue to the login page
        //   next();
        // }
        next({ name: 'default' });
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('../views/account/forgot-password.vue'),
    meta: {
      title: 'Forgot Password',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import('../views/account/reset-password.vue'),
    meta: {
      title: 'Reset Password',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'Logout', authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        let toKeep = ['crm_vuex'];
        let keyToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (!toKeep.includes(key)) {
            keyToRemove.push(key);
          }
        }
        keyToRemove.forEach(element => {
          localStorage.removeItem(element);
        });
        store.commit('setUserId', null);
        sessionStorage.clear();
        next();
      },
    },
    component: () => import('../views/account/logout')
  },
  {
    path: '/',
    name: 'default',
    redirect: { name: 'dashboard' },
  },
  {
    path: '/my-profile',
    name: 'MyProfile',
    meta: { title: 'My Profile', authRequired: true },
    component: () => import('../views/account/my-profile.vue'),
  },
  {
    path: '/notifications',
    name: 'Notifications',
    meta: { title: 'Notifications', authRequired: true },
    component: () => import('../views/notifications/NotificationsList.vue'),
  },
  {
    path: '/document-extraction',
    name: 'DocumentExtraction',
    meta: { title: 'Document Extraction', authRequired: true },
    component: () => import('../views/docs/document-extraction.vue'),
  },
  {
    path: '/document-extraction/list',
    name: 'DocumentExtractionList',
    meta: { title: 'Saved Extractions', authRequired: true },
    component: () => import('../views/docs/document-extraction-list.vue'),
  },
  {
    path: '/document-extraction/view/:id',
    name: 'DocumentExtractionView',
    meta: { title: 'View Extraction', authRequired: true },
    component: () => import('../views/docs/document-extraction-view.vue'),
  },

  // Menus
  {
    path: '/maintenance/menu',
    name: 'Menus',
    meta: { title: 'Menu', authRequired: true },
    component: () => import('../views/maintenance/menus'),
  },
  {
    path: '/maintenance/evaluation',
    name: 'EvaluationOptions',
    meta: { title: 'Evaluation Options', authRequired: true },
    component: () => import('../views/maintenance/evaluation/Index.vue'),
  },
  {
    path: '/maintenance/system-configuration',
    alias: '/system-configuration',
    name: 'SystemConfiguration',
    meta: { title: 'System Configuration', authRequired: true },
    component: () => import('../views/maintenance/system-configuration/SystemConfiguration.vue'),
  },
  {
    path: '/maintenance/menu/form',
    name: 'AddMenu',
    meta: { title: 'Add Menu', authRequired: true },
    component: () => import('../views/maintenance/menus/form'),
  },
  {
    path: '/maintenance/menu/form/:id',
    name: 'EditMenu',
    meta: { title: 'Edit Menu', authRequired: true },
    component: () => import('../views/maintenance/menus/form'),
  },

  // Customers
  {
    path: '/customers/customers_list',
    name: 'Customers',
    meta: { title: 'Customers', authRequired: true },
    component: () => import('../views/customers'),
  },
  {
    path: '/customers/profile/:id',
    name: 'CustomerProfile',
    meta: { title: 'Customers', authRequired: true },
    component: () => import('../views/customers/form'),
  },
  {
    path: '/accreditation-upload/:token',
    name: 'CustomerAccreditation',
    meta: { title: 'Accreditation', authRequired: false },
    component: () => import('../views/customers/accreditation_upload.vue'),
  },
  {
    path: '/public/service-proposal/:token',
    name: 'public_service_proposal',
    meta: { title: 'Service Proposal', authRequired: false },
    component: () => import('../views/service-proposal/PublicView.vue'),
  },
  {
    path: '/public/service-approval/:token',
    name: 'public_service_approval',
    meta: { title: 'Service Approval', authRequired: false },
    component: () => import('../views/service-proposal/ServiceApprovalView.vue'),
  },
  {
    path: '/module-statuses-monitoring',
    name: 'ModuleStatusesMonitoring',
    meta: { title: 'Module Statuses Monitoring', authRequired: true },
    component: () => import('../views/module-statuses-monitoring/Dashboard.vue'),
  },
  {
    path: '/customers/new',
    name: 'NewCustomer',
    meta: { title: 'New Customer', authRequired: true },
    component: () => import('../views/customers/customer_form.vue'),
  },
  // Sales Officer
  {
    path: '/user-management/sale_officer',
    name: 'SalesOfficer',
    meta: { title: 'Sales Officer', authRequired: true },
    component: () => import('../views/user_management/sales_officer/SalesOfficer.vue'),
  },
  // Sales Group
  {
    path: '/user-management/sales-group',
    name: 'SalesGroup',
    meta: { title: 'Sales Group', authRequired: true },
    component: () => import('../views/user_management/sales_group/SalesGroup.vue'),
  },
  {
    path: '/pre_enroll/new',
    name: 'NewPreEnrollCustomer',
    meta: { title: 'New Pre-Enroll Customer', authRequired: true },
    component: () => import('../views/customers/pre_enroll_form_new.vue'),
  },
  {
    path: '/pre_enroll/edit/:id',
    name: 'EditPreEnrollCustomer',
    meta: { title: 'Edit Pre-Enroll Customer', authRequired: true },
    component: () => import('../views/customers/pre_enroll_form_new.vue'),
  },
  {
    path: '/pre_enroll/view/:id',
    name: 'ViewPreEnrollCustomer',
    meta: { title: 'View Pre-Enroll Customer', authRequired: true },
    component: () => import('../views/customers/pre_enroll_form_new.vue'),
  },
  {
    path: '/pre_enroll/profile/:id',
    name: 'PreEnrollProfile',
    meta: { title: 'Pre-Enroll Customer Profile', authRequired: true },
    component: () => import('../views/customers/pre_enroll/PreEnrollProfile.vue'),
  },
  // pre enroll customer
  {
    path: '/customers/pre_enroll',
    name: 'pre_enroll',
    meta: {
      title: 'Pre-Enroll',
      authRequired: true,
    },
    component: () => import('../views/customers/pre_enroll/PreEnroll.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'Dashboard',
      authRequired: true,
    },
    component: () => import('../views/dashboard/meeting_schedule/index.vue'),
  },

  // Client Management Accreditataion Template
  {
    path: '/maintenance/accreditation-template',
    name: 'AccreditationTemplate',
    meta: { title: 'Accreditation Template', authRequired: true },
    component: () => import('../views/maintenance/accreditation-template/index'),
  },

  // Service Capability Evaluation Template
  {
    path: '/maintenance/sce-template',
    name: 'SCETemplate',
    meta: { title: 'SCE Template', authRequired: true },
    component: () => import('../views/maintenance/sce-template/index'),
  },

  // Form Rules — runtime-editable visibility/required/readonly per module field
  {
    path: '/maintenance/form-rules',
    name: 'FormRules',
    meta: { title: 'Form Rules', authRequired: true },
    component: () => import('../views/maintenance/form-rules/FormRules.vue'),
  },

  // Form Builder
  {
    path: '/maintenance/form-builder',
    name: 'FormBuilder',
    meta: { title: 'Form Builder', authRequired: true },
    component: () => import('../views/maintenance/form-builder'),
  },

  {
    path: '/maintenance/form-builder/add',
    name: 'AddFormBuilder',
    meta: { title: 'Add Form', authRequired: true },
    component: () => import('../views/maintenance/form-builder/form'),
  },

  {
    path: '/maintenance/form-builder/:id',
    name: 'EditFormBuilder',
    meta: { title: 'Edit Form', authRequired: true },
    component: () => import('../views/maintenance/form-builder/form'),
  },

  {
    path: '/maintenance/form-builder/view/:id',
    name: 'ViewFormBuilder',
    meta: { title: 'View Form', authRequired: true },
    component: () => import('../views/maintenance/form-builder/view'),
  },

  {
    path: '/response_page/:sales_officer_id/:meeting_schedule_id',
    name: 'response_page',
    component: () => import('../views/dashboard/meeting_schedule/responsePage.vue'),
    meta: {
      title: 'Response',
      authRequired: false,
    },
  },
  {
    path: '/sales_officer/for_proposal',
    name: 'for_proposal',
    meta: {
      title: 'For Proposal',
      authRequired: true,
    },
    component: () => import('../views/sales_officer/for_proposal/forProposal.vue'),
  },
  {
    path: '/project_costing',
    name: 'project_costing',
    meta: {
      title: 'Project Costing',
      authRequired: true,
    },
    component: () => import('../views/project_costing/index'),
  },

  // Inventory Management
  {
    path: '/inventory-management/project-costing',
    name: 'ProjectCosting',
    meta: { title: 'Project Costing', authRequired: true },
    component: () => import('../views/inventory-management/project-costing/create-project/index'),
  },
  {
    path: '/inventory-management/dashboard',
    name: 'InventoryDashboard',
    meta: { title: 'Inventory Dashboard', authRequired: true },
    component: () => import('../views/inventory-management/dashboard/index'),
  },
  {
    path: '/inventory-management/project-costing/categories',
    name: 'Categories',
    meta: { title: 'Categories', authRequired: true },
    component: () => import('../views/inventory-management/project-costing/categories/index'),
  },

  {
    path: '/sales_officer/customer_activity_log',
    name: 'customer_activity_log',
    meta: {
      title: 'Customer Activity Log',
      authRequired: true,
    },
    component: () => import('../views/sales_officer/customer_activity_log/customer_activity_log.vue'),
  },

  {
    path: '/sales_officer/monitoring',
    name: 'sales_officer_monitoring',
    meta: {
      title: 'Sales Officer Monitoring',
      authRequired: true,
    },
    component: () => import('../views/sales_officer/monitoring/monitoring.vue'),
  },

  {
    path: '/crm/dashboard',
    name: 'crm-dashboard',
    meta: {
      title: 'CRM Dashboard',
      authRequired: true,
    },
    component: () => import('../views/crm/dashboard/index.vue'),
  },

  {
    path: '/crm/leads',
    name: 'crm-leads',
    meta: {
      title: 'Leads',
      authRequired: true,
    },
    component: () => import('../views/crm/leads/index.vue'),
  },

  {
    path: '/crm/contacts',
    name: 'crm-contacts',
    meta: {
      title: 'Contacts',
      authRequired: true,
    },
    component: () => import('../views/crm/contacts/index.vue'),
  },

  {
    path: '/crm/customers',
    name: 'crm-customers',
    meta: {
      title: 'Customers',
      authRequired: true,
    },
    component: () => import('../views/crm/customers/index.vue'),
  },

  {
    path: '/crm/deals',
    name: 'crm-deals',
    meta: {
      title: 'Deals',
      authRequired: true,
    },
    component: () => import('../views/crm/deals/index.vue'),
  },

  {
    path: '/chat',
    name: 'chat',
    meta: { title: 'Chat', authRequired: true },
    component: () => import('../views/chat/index.vue'),
  },

  {
    path: '/inbox',
    name: 'inbox',
    meta: { title: 'Inbox', authRequired: true },
    component: () => import('../views/inbox/index.vue'),
  },

  {
    path: '/maintenance/services',
    name: 'services',
    meta: {
      title: 'Services',
      authRequired: true,
    },
    component: () => import('../views/maintenance/services/services.vue'),
  },
  {
    path: '/maintenance/task-status',
    name: 'task-status',
    meta: {
      title: 'Task Status',
      authRequired: true,
    },
    component: () => import('../views/maintenance/task-status/TaskStatus.vue'),
  },
  {
    path: '/maintenance/task-module',
    name: 'task-module',
    meta: {
      title: 'Task Module',
      authRequired: true,
    },
    component: () => import('../views/maintenance/task-module/TaskModule.vue'),
  },
  {
    path: '/maintenance/uom',
    name: 'uom',
    meta: {
      title: 'Unit of Measure',
      authRequired: true,
    },
    component: () => import('../views/maintenance/uom/uom.vue'),
  },
  {
    path: '/maintenance/incoterms',
    name: 'incoterms',
    meta: {
      title: 'Incoterms',
      authRequired: true,
    },
    component: () => import('../views/maintenance/incoterms/incoterms.vue'),
  },
  {
    path: '/maintenance/customer-types',
    name: 'customer-types',
    meta: {
      title: 'Customer Types',
      authRequired: true,
    },
    component: () => import('../views/maintenance/customer-types/Index.vue'),
  },
  {
    path: '/maintenance/dispatch-group',
    name: 'dispatch-group',
    meta: {
      title: 'Dispatch Groups',
      authRequired: true,
    },
    component: () => import('../views/maintenance/dispatch-group/Index.vue'),
  },
  {
    path: '/maintenance/departments',
    name: 'departments',
    meta: {
      title: 'Departments',
      authRequired: true,
    },
    component: () => import('../views/maintenance/departments/departments.vue'),
  },
  {
    path: '/maintenance/clauses',
    name: 'clauses',
    meta: {
      title: 'Instruction Clause Library',
      authRequired: true,
    },
    component: () => import('../views/maintenance/clauses/Index.vue'),
  },
  {
    path: '/user-management/permissions',
    name: 'permissions',
    meta: {
      title: 'Permissions',
      authRequired: true,
    },
    component: () => import('../views/user_management/permissions/permissions.vue'),
  },
  {
    path: '/user-management/roles',
    name: 'roles',
    meta: {
      title: 'Roles',
      authRequired: true,
    },
    component: () => import('../views/user_management/roles/roles.vue'),
  },
  {
    path: '/user-management/roles/view/:id',
    name: 'view_role',
    meta: {
      title: 'View Role',
      authRequired: true,
    },
    component: () => import('../views/user_management/roles/RolePermissionPage.vue'),
  },
  {
    path: '/maintenance/company',
    name: 'company',
    meta: {
      title: 'Companies',
      authRequired: true,
    },
    component: () => import('../views/maintenance/company/company.vue'),
  },
  {
    path: '/user-management/users',
    name: 'users',
    meta: {
      title: 'Users',
      authRequired: true,
    },
    component: () => import('../views/user_management/users/users.vue'),
  },
  {
    path: '/user-management/users/create',
    name: 'user-create',
    meta: {
      title: 'Create User',
      authRequired: true,
    },
    component: () => import('../views/user_management/users/UserForm.vue'),
  },
  {
    path: '/user-management/users/edit/:id',
    name: 'user-edit',
    meta: {
      title: 'Edit User',
      authRequired: true,
    },
    component: () => import('../views/user_management/users/UserForm.vue'),
  },
  {
    path: '/user-management/designations',
    name: 'designations',
    meta: {
      title: 'Designation',
      authRequired: true,
    },
    component: () => import('../views/user_management/designations/designations.vue'),
  },
  {
    path: '/maintenance/airport-codes',
    name: 'airport-codes',
    meta: {
      title: 'Airport Codes',
      authRequired: true,
    },
    component: () => import('../views/maintenance/airport-codes/airportCodes.vue'),
  },
  {
    path: '/maintenance/commodity',
    name: 'commodity',
    meta: {
      title: 'Commodity',
      authRequired: true,
    },
    component: () => import('../views/maintenance/commodity/commodity.vue'),
  },
  {
    path: '/maintenance/station',
    name: 'station',
    meta: {
      title: 'Stations',
      authRequired: true,
    },
    component: () => import('../views/maintenance/station/station.vue'),
  },
  {
    path: '/maintenance/banks',
    name: 'banks',
    meta: {
      title: 'Banks',
      authRequired: true,
    },
    component: () => import('../views/maintenance/banks/banks.vue'),
  },
  {
    path: '/maintenance/brokers',
    name: 'brokers',
    meta: {
      title: 'Brokers',
      authRequired: true,
    },
    component: () => import('../views/maintenance/brokers/brokers.vue'),
  },
  {
    path: '/maintenance/currency',
    name: 'currencies',
    meta: {
      title: 'Currencies',
      authRequired: true,
    },
    component: () => import('../views/maintenance/currency/currencies.vue'),
  },
  {
    path: '/maintenance/currencies',
    name: 'currencies_alias',
    meta: {
      title: 'Currencies',
      authRequired: true,
    },
    component: () => import('../views/maintenance/currency/currencies.vue'),
  },
  {
    path: '/maintenance/bank_branches',
    name: 'bank_branches',
    meta: {
      title: 'Bank Branches',
      authRequired: true,
    },
    component: () => import('../views/maintenance/banks/banks_branches.vue'),
  },
  {
    path: '/maintenance/hs_code',
    name: 'hs_code',
    meta: {
      title: 'HS Code',
      authRequired: true,
    },
    component: () => import('../views/maintenance/hs_code/hs_code.vue'),
  },
  {
    path: '/maintenance/customs-warehouse',
    name: 'customs-warehouse',
    meta: {
      title: 'Customs Warehouse',
      authRequired: true,
    },
    component: () => import('../views/maintenance/customs_warehouse/customs_warehouse.vue'),
  },
  {
    path: '/pod-entry',
    name: 'pod-entry',
    meta: {
      title: 'POD Entry',
      authRequired: true,
    },
    component: () => import('../views/pod-entry/PodEntry.vue'),
  },
  {
    path: '/maintenance/status-list',
    name: 'status-list',
    meta: {
      title: 'POD Status List',
      authRequired: true,
    },
    component: () => import('../views/maintenance/status-list/StatusList.vue'),
  },
  {
    path: '/maintenance/att-docs',
    name: 'att-docs',
    meta: {
      title: 'Attached Documents',
      authRequired: true,
    },
    component: () => import('../views/maintenance/att_docs/att_docs.vue'),
  },
  {
    path: '/maintenance/att_docs',
    name: 'att_docs',
    meta: {
      title: 'Attached Documents',
      authRequired: true,
    },
    component: () => import('../views/maintenance/att_docs/att_docs.vue'),
  },
  {
    path: '/maintenance/invoice-stock',
    name: 'invoice-stock',
    meta: {
      title: 'Invoice Stock',
      authRequired: true,
    },
    component: () => import('../views/invoice_stock/invoice_stock.vue'),
  },
  {
    path: '/maintenance/invoice_stock',
    name: 'invoice_stock',
    meta: {
      title: 'Invoice Stock',
      authRequired: true,
    },
    component: () => import('../views/invoice_stock/invoice_stock.vue'),
  },
  {
    path: '/invoice-stock',
    name: 'invoice_stock_root',
    meta: {
      title: 'Invoice Stock',
      authRequired: true,
    },
    component: () => import('../views/invoice_stock/invoice_stock.vue'),
  },
  {
    path: '/maintenance/customs-procedure',
    name: 'customs-procedure',
    meta: {
      title: 'Customs Procedure',
      authRequired: true,
    },
    component: () => import('../views/maintenance/customs_procedure/customs_procedure.vue'),
  },
  {
    path: '/maintenance/customs_procedure',
    name: 'customs_procedure',
    meta: {
      title: 'Customs Procedure',
      authRequired: true,
    },
    component: () => import('../views/maintenance/customs_procedure/customs_procedure.vue'),
  },
  {
    path: '/maintenance/port-subport',
    name: 'port-subport',
    meta: {
      title: 'Port/Subport',
      authRequired: true,
    },
    component: () => import('../views/maintenance/port_subport/port_subport.vue'),
  },
  {
    path: '/maintenance/mode-of-declaration',
    name: 'mode-of-declaration',
    meta: {
      title: 'Mode of Declaration',
      authRequired: true,
    },
    component: () => import('../views/maintenance/mode_of_declaration/mode_of_declaration.vue'),
  },
  {
    path: '/maintenance/terms-of-payment',
    name: 'terms-of-payment',
    meta: {
      title: 'Terms of Payment',
      authRequired: true,
    },
    component: () => import('../views/maintenance/terms_delivery_payment/terms_of_payment.vue'),
  },
  {
    path: '/maintenance/terms_of_payment',
    name: 'terms_of_payment_alias',
    meta: {
      title: 'Terms of Payment',
      authRequired: true,
    },
    component: () => import('../views/maintenance/terms_delivery_payment/terms_of_payment.vue'),
  },
  {
    path: '/maintenance/terms-of-delivery',
    name: 'terms-of-delivery',
    meta: {
      title: 'Terms of Delivery',
      authRequired: true,
    },
    component: () => import('../views/maintenance/terms_delivery_payment/terms_of_delivery.vue'),
  },
  {
    path: '/maintenance/terms_of_delivery',
    name: 'terms_of_delivery_alias',
    meta: {
      title: 'Terms of Delivery',
      authRequired: true,
    },
    component: () => import('../views/maintenance/terms_delivery_payment/terms_of_delivery.vue'),
  },
  {
    path: '/maintenance/mawb-series',
    name: 'mawb-series',
    meta: {
      title: 'MAWB Series',
      authRequired: true,
    },
    props: { seriesType: 'MAWB' },
    component: () => import('../views/maintenance/awb-series/AwbSeries.vue'),
  },
  {
    path: '/maintenance/hawb-series',
    name: 'hawb-series',
    meta: {
      title: 'HAWB Series',
      authRequired: true,
    },
    props: { seriesType: 'HAWB' },
    component: () => import('../views/maintenance/awb-series/AwbSeries.vue'),
  },
  {
    path: '/maintenance/airline',
    name: 'airline',
    meta: {
      title: 'Airline',
      authRequired: true,
    },
    component: () => import('../views/maintenance/airline/airline.vue'),
  },
  {
    path: '/maintenance/airline-gsa',
    name: 'airline_gsa',
    meta: {
      title: 'Airline GSA',
      authRequired: true,
    },
    component: () => import('../views/maintenance/airline-gsa/AirlineGsa.vue'),
  },
  {
    path: '/maintenance/orig_dest_air',
    name: 'orig-dest-air',
    meta: {
      title: 'Origin-Destination (Air)',
      authRequired: true,
    },
    component: () => import('../views/maintenance/orig_dest_air/orig_dest_air.vue'),
  },
  {
    path: '/maintenance/flight-schedule',
    name: 'flight-schedule',
    meta: {
      title: 'Flight Schedule',
      authRequired: true,
    },
    component: () => import('../views/maintenance/flight_schedule/flight_schedule.vue'),
  },
  {
    path: '/certificate-of-origin/entry/:ref?',
    name: 'certificate-of-origin-entry',
    meta: {
      title: 'Certificate of Origin',
      authRequired: true,
    },
    component: () => import('../views/certificate_of_origin/CertificateOfOriginEntry.vue'),
  },
  {
    path: '/maintenance/orig_dest_sea',
    name: 'orig-dest-sea',
    meta: {
      title: 'Origin-Destination (Sea)',
      authRequired: true,
    },
    component: () => import('../views/maintenance/orig_dest_sea/orig_dest_sea.vue'),
  },
  {
    path: '/maintenance/charges_list',
    name: 'charges_list',
    meta: {
      title: 'Charges List',
      authRequired: true,
    },
    component: () => import('../views/maintenance/charges_list/charges_list.vue'),
  },
  {
    path: '/maintenance/weight_break',
    name: 'weight_break',
    meta: {
      title: 'Weight Break',
      authRequired: true,
    },
    component: () => import('../views/maintenance/weight_break/weight_break.vue'),
  },
  {
    path: '/maintenance/iata-rates',
    name: 'iata_rate',
    meta: {
      title: 'IATA Rate',
      authRequired: true,
    },
    component: () => import('../views/maintenance/iata_rate/iata_rate.vue'),
  },
  {
    path: '/maintenance/airline-rates',
    name: 'airline_rate',
    meta: {
      title: 'Airline Rate',
      authRequired: true,
    },
    component: () => import('../views/maintenance/airline_rate/airline_rate.vue'),
  },
  {
    path: '/maintenance/shipping-lines',
    name: 'shipping_lines',
    meta: {
      title: 'Shipping Lines',
      authRequired: true,
    },
    component: () => import('../views/maintenance/shipping_lines/shipping_line.vue'),
  },
  {
    path: '/maintenance/container-types',
    name: 'container_types',
    meta: {
      title: 'Container Types',
      authRequired: true,
    },
    component: () => import('../views/maintenance/container_type/ContainerType.vue'),
  },
  {
    path: '/maintenance/agent-rate-card',
    alias: '/maintenance/agent-rate-cards',
    name: 'agent_rate_card',
    meta: {
      title: 'Agent Rate Cards',
      authRequired: true,
    },
    component: () => import('../views/maintenance/agent_rate_card/index.vue'),
  },
  {
    path: '/maintenance/agent-rate-card/:id',
    name: 'agent_rate_card_detail',
    meta: {
      title: 'Agent Rate Card Groups & Details',
      authRequired: true,
    },
    component: () => import('../views/maintenance/agent_rate_card/detail.vue'),
  },
  {
    path: '/maintenance/ocean-freight-rates',
    name: 'ocean_freight_rates',
    meta: {
      title: 'Ocean Freight Rates',
      authRequired: true,
    },
    component: () => import('../views/maintenance/ocean-freight-rates/OceanFreightRates.vue'),
  },
  {
    path: '/maintenance/airline-class',
    name: 'airline_class',
    meta: {
      title: 'Airline Class',
      authRequired: true,
    },
    component: () => import('../views/maintenance/airline_class/airline_class.vue'),
  },
  {
    path: '/maintenance/exchange-rates',
    name: 'exchange_rate',
    meta: {
      title: 'Exchange Rate',
      authRequired: true,
    },
    component: () => import('../views/maintenance/exchange_rate/exchange_rate.vue'),
  },
  {
    path: '/maintenance/tariffs',
    name: 'Tariffs',
    meta: { title: 'Tariffs', authRequired: true },
    component: () => import('../views/maintenance/tariffs/index.vue'),
  },
  {
    path: '/maintenance/tariffs/create',
    name: 'TariffCreate',
    meta: { title: 'Create Tariff', authRequired: true },
    component: () => import('../views/maintenance/tariffs/create.vue'),
  },
  {
    path: '/maintenance/tariffs/edit/:id',
    name: 'TariffEdit',
    meta: { title: 'Edit Tariff', authRequired: true },
    component: () => import('../views/maintenance/tariffs/edit.vue'),
  },
  {
    path: '/maintenance/tariff-templates',
    name: 'TariffTemplates',
    meta: { title: 'Tariff Templates', authRequired: true },
    component: () => import('../views/maintenance/tariff-template/Index.vue'),
  },
  {
    path: '/maintenance/airline-surcharges',
    name: 'airline_surcharges',
    meta: {
      title: 'Airline Surcharges',
      authRequired: true,
    },
    component: () => import('../views/maintenance/airline_surcharges/airline_surcharges.vue'),
  },
  {
    path: '/maintenance/ocean-surcharges',
    name: 'ocean_surcharges',
    meta: {
      title: 'Ocean Surcharges',
      authRequired: true,
    },
    component: () => import('../views/maintenance/ocean-surcharges/OceanSurcharges.vue'),
  },
  {
    path: '/csr',
    name: 'csr',
    meta: {
      title: 'Customer Service Record',
      authRequired: true,
    },
    component: () => import('../views/csr/CsrList.vue'),
  },
  {
    path: '/csr/csr-entry',
    name: 'CsrEntry',
    meta: {
      title: 'CSR Entry',
      authRequired: true,
    },
    component: () => import('../views/csr/CsrEntry.vue'),
  },
  {
    path: '/csr/edit/:id',
    name: 'EditCsr',
    meta: {
      title: 'Edit CSR',
      authRequired: true,
    },
    component: () => import('../views/csr/CsrEditing.vue'),
  },
  {
    path: '/csr/approver-preview/:token',
    name: 'CsrApproverPreview',
    meta: {
      title: 'CSR Approval',
      authRequired: false,
    },
    component: () => import('../views/csr/CsrApproverPreview.vue'),
  },
  {
    path: '/csr/import',
    name: 'ImportCsr',
    meta: {
      title: 'Import CSR',
      authRequired: true,
    },
    component: () => import('../views/csr/import/ImportCsr.vue'),
  },
  {
    path: '/csr/import-freight-rates',
    name: 'ImportFreightRates',
    meta: {
      title: 'Import Freight Rates',
      authRequired: true,
    },
    component: () => import('../views/csr/import/importFreightRates.vue'),
  },
  {
    path: '/csr/import-charges',
    name: 'ImportCharges',
    meta: {
      title: 'Import Charges',
      authRequired: true,
    },
    component: () => import('../views/csr/import/importCharges.vue'),
  },
  {
    path: '/csr/import-profit-share',
    name: 'ImportProfitShare',
    meta: {
      title: 'Import Profit Share',
      authRequired: true,
    },
    component: () => import('../views/csr/import/ImportProfitShare.vue'),
  },
  {
    path: '/csr/import-trucking',
    name: 'ImportTrucking',
    meta: {
      title: 'Import Trucking',
      authRequired: true,
    },
    component: () => import('../views/csr/import/ImportTrucking.vue'),
  },
  {
    path: '/csr/import-instruction',
    name: 'ImportInstrucction',
    meta: {
      title: 'Import Instruction',
      authRequired: true,
    },
    component: () => import('../views/csr/import/ImportInstrucction.vue'),
  },
  {
    path: '/csr/import-pre-alert',
    name: 'ImportPreAlert',
    meta: {
      title: 'Import Pre-Alert',
      authRequired: true,
    },
    component: () => import('../views/csr/import/ImportPreAlert.vue'),
  },
  {
    path: '/customers/import',
    name: 'ImportCustomer',
    meta: {
      title: 'Import Customer',
      authRequired: true,
    },
    component: () => import('../views/csr/import/ImportCustomer.vue'),
  },
  {
    path: '/csr/dc',
    name: 'CsrDataController',
    meta: {
      title: 'CSR Data Controller',
      authRequired: true,
    },
    component: () => import('../views/csr/import/data-controller/Datas.vue'),
  },
  {
    path: '/maintenance/trucking',
    name: 'trucking_maintenance',
    meta: {
      title: 'Trucking Maintenance',
      authRequired: true,
    },
    component: () => import('../views/maintenance/trucking/Index.vue'),
  },
  {
    path: '/maintenance/trucking/area-codes',
    name: 'area_codes',
    meta: {
      title: 'Area Codes',
      authRequired: true,
    },
    component: () => import('../views/maintenance/trucking/AreaCodes.vue'),
  },
  {
    path: '/maintenance/trucking/net-rates',
    name: 'net_rates',
    meta: {
      title: 'Trucking Net Rates',
      authRequired: true,
    },
    component: () => import('../views/maintenance/trucking/NetRates.vue'),
  },
  {
    path: '/maintenance/trucking/base-rates',
    name: 'base_rates',
    alias: ['/maintenance/trucking/selling-rates'],
    meta: {
      title: 'Trucking Base Rates',
      authRequired: true,
    },
    component: () => import('../views/maintenance/trucking/BaseRates.vue'),
  },
  {
    path: '/maintenance/trucker-rates',
    name: 'trucker_rates',
    meta: {
      title: 'Trucker Rates (TMS)',
      authRequired: true,
    },
    component: () => import('../views/maintenance/trucker-rates/index.vue'),
  },
  {
    path: '/maintenance/rate-inquiry',
    name: 'rate_inquiry',
    meta: {
      title: 'Rate Inquiry',
      authRequired: true,
    },
    component: () => import('../views/maintenance/trucker-rates/inquiry.vue'),
  },
  {
    path: '/search-center',
    name: 'search_center',
    meta: {
      title: 'Search Center',
      authRequired: true,
    },
    component: () => import('../views/search_center/index.vue'),
  },
  {
    path: '/maintenance/trucking/assessorial-charges',
    name: 'assessorial_charges',
    meta: {
      title: 'Assessorial Charges',
      authRequired: true,
    },
    component: () => import('../views/maintenance/trucking/AssessorialCharges.vue'),
  },
  {
    path: '/booking/export_air',
    name: 'export_air',
    meta: {
      title: 'Export Air',
      authRequired: true,
    },
    component: () => import('../views/booking/export_air.vue'),
  },
  {
    path: '/duties_taxes',
    name: 'duties_taxes',
    meta: {
      title: 'Duties and Taxes',
      authRequired: true,
    },
    component: () => import('../views/duties_taxes/duties_taxes.vue'),
  },
  {
    path: '/booking/domestic',
    name: 'domestic',
    meta: {
      title: 'Domestic',
      authRequired: true,
    },
    component: () => import('../views/booking/domestic.vue'),
  },
  {
    path: '/booking/bookings_list',
    name: 'bookings_list',
    meta: {
      title: 'Booking List',
      authRequired: true,
    },
    component: () => import('../views/booking/bookings_list.vue'),
  },
  {
    path: '/transport-booking-request',
    name: 'transport_booking_request',
    meta: {
      title: 'Transport Booking Request',
      authRequired: true,
    },
    component: () => import('../views/transport-booking-request/index.vue'),
  },
  {
    path: '/tbr-entry',
    name: 'tbr_entry',
    meta: {
      title: 'Transport Booking Request',
      authRequired: true,
    },
    component: () => import('../views/transport-booking-request/entry.vue'),
  },
  {
    path: '/booking/booking_tasks',
    name: 'booking_tasks',
    meta: {
      title: 'Booking Monitoring',
      authRequired: true,
    },
    component: () => import('../views/booking/booking_tasks.vue'),
  },
  {
    path: '/job-order/monitoring',
    name: 'job_order_monitoring',
    meta: {
      title: 'Flight & Port Transaction Monitoring',
      authRequired: true,
    },
    component: () => import('../views/job-order/JobOrderMonitoring.vue'),
  },
  {
    path: '/job-order/daily-tally-sheet',
    name: 'job_order_daily_tally_sheet',
    meta: {
      title: 'Daily Tally Sheet',
      authRequired: true,
    },
    component: () => import('../views/job-order/report/daily-tally-sheet/DailyTallySheet.vue'),
  },
  {
    path: '/job-order/ia-manifest-monitoring',
    name: 'ia_manifest_monitoring',
    meta: {
      title: 'IA Manifest Compliance Monitor',
      authRequired: true,
    },
    component: () => import('../views/job-order/ImportAirManifestMonitoring.vue'),
  },
  {
    path: '/job-order/list',
    name: 'job_order_list',
    meta: {
      title: 'Job Orders',
      authRequired: true,
    },
    component: () => import('../views/job-order/JobOrderList.vue'),
  },
  {
    path: '/job-order/ia-document/:consolRef?',
    name: 'JobOrderIaDocuments',
    meta: { title: 'IA Documents', authRequired: true },
    component: () => import('../views/docs/document-extraction-list.vue'),
  },
  {
    path: '/job-order/entry/:service(ea|ia|is|es|br|ba|bs|os|EA|IA|IS|ES|BR|BA|BS|OS)/:id?',
    name: 'job_order_entry',
    meta: {
      title: 'Job Order Entry',
      authRequired: true,
    },
    component: () => import('../views/job-order/JobOrderEntryDispatcher.vue'),
    props: true,
  },
  {
    path: '/job-order/entry/:id?',
    name: 'job_order_entry_legacy',
    meta: {
      title: 'Job Order Entry Fallback',
      authRequired: true,
    },
    component: () => import('../views/job-order/JobOrderEntryDispatcher.vue'),
    props: true,
  },
  {
    path: '/job-queue',
    name: 'job_queue',
    meta: {
      title: 'Job Queue',
      authRequired: true,
    },
    component: () => import('../views/job-queue/index.vue'),
  },
  {
    path: '/transfer-manifest',
    name: 'transfer_manifest',
    meta: {
      title: 'Transfer Manifest',
      authRequired: true,
    },
    component: () => import('../views/transfer-manifest/index.vue'),
  },
  {
    path: '/transfer-manifest/entry/:id?',
    name: 'transfer_manifest_entry',
    meta: {
      title: 'Transfer Manifest Entry',
      authRequired: true,
    },
    component: () => import('../views/transfer-manifest/entry.vue'),
    props: true,
  },
  {
    path: '/service-proposal',
    name: 'service_proposal',
    meta: {
      title: 'Service Proposal',
      authRequired: true,
    },
    component: () => import('../views/service-proposal/Index.vue'),
  },
  {
    path: '/service-proposal/create',
    name: 'service_proposal_create',
    meta: {
      title: 'New Service Proposal',
      authRequired: true,
    },
    component: () => import('../views/service-proposal/Create.vue'),
  },
  {
    path: '/service-proposal/edit/:id',
    name: 'service_proposal_edit',
    meta: {
      title: 'Edit Service Proposal',
      authRequired: true,
    },
    component: () => import('../views/service-proposal/Create.vue'),
  },
  {
    path: '/service-proposal/show/:id',
    name: 'service_proposal_show',
    meta: {
      title: 'View Service Proposal',
      authRequired: true,
    },
    component: () => import('../views/service-proposal/Show.vue'),
  },
  {
    path: '/service-proposal/simulation',
    name: 'service_proposal_simulation',
    meta: {
      title: 'Service Proposal Simulation',
      authRequired: true,
    },
    component: () => import('../views/service-proposal/Simulation.vue'),
  },
  {
    path: '/service-proposal/:id/view-services/:serviceId?',
    name: 'service_proposal_view_services',
    meta: {
      title: 'View Services',
      authRequired: true,
    },
    component: () => import('../views/service-proposal/ViewServices.vue'),
  },
  {
    path: '/service-proposal/:proposalId/service/:serviceId/entry',
    name: 'service_proposal_entry',
    meta: {
      title: 'Service Proposal Entry',
      authRequired: true
    },
    component: () => import('../views/service-proposal/Entry.vue')
  },
  {
    path: '/service-proposal/services-templates',
    name: 'service_proposal_services_templates',
    meta: {
      title: 'SP Services Templates',
      authRequired: true
    },
    component: () => import('../views/service-proposal/ServiceTemplates.vue')
  },
  {
    path: '/service-proposal/services-templates/create',
    name: 'service_proposal_template_create',
    meta: {
      title: 'Create Service Template',
      authRequired: true
    },
    component: () => import('../views/service-proposal/TemplateForm.vue')
  },
  {
    path: '/service-proposal/services-templates/:id/edit',
    name: 'service_proposal_template_edit',
    meta: {
      title: 'Edit Service Template',
      authRequired: true
    },
    component: () => import('../views/service-proposal/TemplateForm.vue')
  },
  {
    path: '/service-proposal/letter-templates',
    name: 'service_proposal_letter_templates',
    meta: {
      title: 'SP Letter Templates',
      authRequired: true
    },
    component: () => import('../views/service-proposal/LetterTemplates.vue')
  },
  {
    path: '/service-proposal/reports/awarded-services',
    name: 'service_proposal_awarded_report',
    meta: {
      title: 'SP Services Awarded Report',
      authRequired: true
    },
    component: () => import('../views/service-proposal/AwardedServicesReport.vue')
  },
  {
    path: '/service-proposal/awarded-report',
    redirect: '/service-proposal/reports/awarded-services'
  },
  {
    path: '/maintenance/conversion-rates',
    name: 'conversion_rates',
    meta: {
      title: 'Conversion Rates',
      authRequired: true
    },
    component: () => import('../views/maintenance/conversion_rate/conversion_rate.vue')
  },

  // Task Dashboard & Monitoring
  {
    path: '/my-shared-tasks',
    name: 'MySharedTask',
    meta: {
      title: 'Tasks',
      authRequired: true,
    },
    component: () => import('../views/shared-task/MySharedTask.vue'),
  },
  {
    path: '/shared-tasks',
    name: 'SharedTask',
    meta: {
      title: 'Task Monitoring',
      authRequired: true,
    },
    component: () => import('../views/shared-task/SharedTask.vue'),
  },

  // Liquidation
  {
    path: '/liquidation',
    name: 'liquidation',
    meta: {
      title: 'Liquidation',
      authRequired: true,
    },
    component: () => import('../views/liquidation/Index.vue'),
  },
  {
    path: '/liquidation/create',
    name: 'liquidation_create',
    meta: {
      title: 'Create Liquidation',
      authRequired: true,
    },
    component: () => import('../views/liquidation/Create.vue'),
  },
  {
    path: '/liquidation/view/:id',
    name: 'liquidation_view',
    meta: {
      title: 'View Liquidation',
      authRequired: true,
    },
    component: () => import('../views/liquidation/Show.vue'),
  },
  {
    path: '/liquidation/pcv-summary-report',
    name: 'liquidation_pcv_summary_report',
    meta: {
      title: 'PCV Summary Report',
      authRequired: true,
    },
    component: () => import('../views/liquidation/PcvSummaryReport.vue'),
  },
  {
    path: '/liquidation/pcv-transmittal/:transmittal_no?',
    name: 'liquidation_pcv_transmittal',
    meta: {
      title: 'PCV Transmittal',
      authRequired: true,
    },
    component: () => import('../views/liquidation/PcvTransmittal.vue'),
  },
  {
    path: '/billing',
    name: 'billing',
    meta: {
      title: 'Billing',
      authRequired: true,
    },
    component: () => import('../views/billing/Index.vue'),
  },
  {
    path: '/billing/create',
    name: 'billing_create',
    meta: {
      title: 'New Billing Entry',
      authRequired: true,
    },
    component: () => import('../views/billing/BillingEntry.vue'),
  },
  {
    path: '/billing/entry/:id?',
    name: 'billing_entry',
    meta: {
      title: 'Billing Entry',
      authRequired: true,
    },
    component: () => import('../views/billing/BillingEntry.vue'),
    props: true,
  },
  {
    path: '/billing/view/:id',
    name: 'billing_view',
    meta: {
      title: 'View Billing',
      authRequired: true,
    },
    component: () => import('../views/billing/BillingEntry.vue'),
    props: true,
  },
  {
    path: '/documents',
    name: 'document_parser',
    meta: {
      title: 'Document Parser',
      authRequired: true,
    },
    component: () => import('../views/documents/index.vue'),
  },
  {
    path: '/documents/list',
    redirect: '/documents',
  },
  {
    path: '/documents/create',
    redirect: '/documents',
  },
  {
    path: '/documents/view/:id',
    name: 'document_parser_view',
    meta: {
      title: 'Document Parser - Studio & Verification',
      authRequired: true,
    },
    component: () => import('../views/documents/editor.vue'),
  },
  {
    path: '/documents/edit/:id',
    name: 'document_parser_edit',
    meta: {
      title: 'Document Parser - Studio & Edit',
      authRequired: true,
    },
    component: () => import('../views/documents/editor.vue'),
  },
  {
    path: '/documents/:id',
    redirect: to => `/documents/view/${to.params.id}`,
  }
];
